/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const ArrowUpDown = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M3.12618 7.37384L2.02783 6.35087L5.91739 2.46131C6.50317 1.87553 7.45292 1.87553 8.03871 2.46131L11.9283 6.35088L10.8299 7.37385L7.72806 4.27198V20.0082H6.22806V4.27196L3.12618 7.37384Z"
                        fill={color}
                    />
                    <path
                        d="M13.1565 16.6564L12.0581 17.6793L15.9477 21.5689C16.5334 22.1547 17.4832 22.1547 18.069 21.5689L21.9585 17.6793L20.8602 16.6564L17.7583 19.7582V4.00824H16.2583V19.7583L13.1565 16.6564Z"
                        fill={color}
                    />
                </svg>
        );
    };
